"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dollarToUSD = dollarToUSD;
exports.centsToUSD = centsToUSD;
exports.calculateDiscountPrice = calculateDiscountPrice;
exports.centsToDollar = centsToDollar;
exports.getDiscountPrice = getDiscountPrice;

/**
 *
 * @param amount in dollars
 * @returns USD
 */
function dollarToUSD(amount) {
  if (!Number.isFinite(amount)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
}
/**
 *
 * @param amount in cents
 * @returns USD
 */


function centsToUSD(amount) {
  if (!Number.isFinite(amount)) return '';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(centsToDollar(amount));
}
/**
 *
 * @param subTotal in dollars
 * @param discountAmount in percentage
 * @returns dollar
 */


function calculateDiscountPrice(subTotal, discountAmount) {
  return subTotal * discountAmount / 100;
}
/**
 *
 * @param number in cents
 * @returns dollars
 */


function centsToDollar(number) {
  return number / 100;
}
/**
 *
 * @param subTotal in dollars
 * @param discountAmount in dollars | in percentage (number with 2 decimal places)
 * @param discountMethod 'amount' | 'percentage'
 * @returns USD
 */


function getDiscountPrice(subTotal, discountAmount, discountMethod) {
  if (discountMethod === 'amount') {
    return dollarToUSD(discountAmount);
  } else {
    return dollarToUSD(calculateDiscountPrice(subTotal, discountAmount));
  }
}